// @ts-ignore
import React from "react";

import { AppPricingData } from "../../contentful";
import { ConfluenceSoftwarePageTemplate } from "../../templates/confluence-software-page/src";

export type ConfluenceSoftwarePageProps = {
    pricing?: AppPricingData;
};

export const ConfluenceSoftwarePage = (props: ConfluenceSoftwarePageProps) => (
    <ConfluenceSoftwarePageTemplate pricing={props.pricing} />
);
